module.exports = __webpack_public_path__ + "static/cstoreslider-20-min-62ebe0d81bfd718513a6938671c2a0a8.jpg";